import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    title: {
        id: '_.xsell.tooltip.title',
        defaultMessage: 'Available credit amounts depend on the repayment type:'
    },
    flexiRange: {
        id: '_.xsell.tooltip.flexi_range',
        defaultMessage:
            'Repayment in {months} monthly installments: {min} - {max}'
    },
    rblRange: {
        id: '_.xsell.tooltip.rbl_range',
        defaultMessage: 'Refund with revenue share: {min} - {max}'
    },
    interestOnlyRange: {
        id: '_.xsell.tooltip.interest_only_range',
        defaultMessage: 'Repayment with grace period: {min} - {max}'
    }
});
